import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import { NavBar } from '@/components/NavBar';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { Home } from '@/pages/Home';
import { Platform } from '@/pages/Platform';
import { FeatureDetail } from '@/pages/FeatureDetail';
import { Roadmap } from '@/pages/Roadmap';
import { WhatsNew } from '@/pages/WhatsNew';
import { Blog } from '@/pages/Blog';
import { BlogPost } from '@/pages/BlogPost';
import { ForSmallMsps } from '@/pages/ForSmallMsps';
import { Compliance } from '@/pages/Compliance';
import { ComplianceDetail } from '@/pages/ComplianceDetail';
import { Integrations } from '@/pages/Integrations';
import { IntegrationDetail } from '@/pages/IntegrationDetail';
import { SolutionsConsolidation } from '@/pages/SolutionsConsolidation';
import { SolutionsEducation } from '@/pages/SolutionsEducation';
import { SolutionsMspOwners } from '@/pages/SolutionsMspOwners';
import { SolutionsTechnicians } from '@/pages/SolutionsTechnicians';
import { SolutionsVcio } from '@/pages/SolutionsVcio';
import { SolutionsGrowingMsps } from '@/pages/SolutionsGrowingMsps';
import { SolutionsSecurityFirst } from '@/pages/SolutionsSecurityFirst';
import { SolutionsHealthcare } from '@/pages/SolutionsHealthcare';
import { SolutionsFinancialServices } from '@/pages/SolutionsFinancialServices';
import { SolutionsNonprofits } from '@/pages/SolutionsNonprofits';
import { Glossary } from '@/pages/Glossary';
import { GlossaryDetail } from '@/pages/GlossaryDetail';
import { Compare } from '@/pages/Compare';
import { CompareDetail } from '@/pages/CompareDetail';
import { BuyersGuide } from '@/pages/BuyersGuide';
import { Press } from '@/pages/Press';
import { Contact } from '@/pages/Contact';
import { Resources } from '@/pages/Resources';
import { About } from '@/pages/About';
import { Security } from '@/pages/Security';
import { Privacy } from '@/pages/Privacy';
import { Terms } from '@/pages/Terms';
import { NotFound } from '@/pages/NotFound';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Box className="min-h-screen">
        <NavBar />
        <Box component="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/platform/:slug" element={<FeatureDetail />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/whats-new" element={<WhatsNew />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/for-small-msps" element={<ForSmallMsps />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/compliance/:slug" element={<ComplianceDetail />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/integrations/:slug" element={<IntegrationDetail />} />
            <Route path="/solutions/it-consolidation" element={<SolutionsConsolidation />} />
            <Route path="/solutions/education" element={<SolutionsEducation />} />
            <Route path="/solutions/msp-owners" element={<SolutionsMspOwners />} />
            <Route path="/solutions/technicians" element={<SolutionsTechnicians />} />
            <Route path="/solutions/vcio" element={<SolutionsVcio />} />
            <Route path="/solutions/growing-msps" element={<SolutionsGrowingMsps />} />
            <Route path="/solutions/security-first-msps" element={<SolutionsSecurityFirst />} />
            <Route path="/solutions/healthcare" element={<SolutionsHealthcare />} />
            <Route path="/solutions/financial-services" element={<SolutionsFinancialServices />} />
            <Route path="/solutions/nonprofits" element={<SolutionsNonprofits />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/glossary/:slug" element={<GlossaryDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/compare/:slug" element={<CompareDetail />} />
            <Route path="/buyers-guide" element={<BuyersGuide />} />
            <Route path="/press" element={<Press />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/security" element={<Security />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </BrowserRouter>
  );
}
